module.exports = __webpack_public_path__ + "img/review-grid-section-03.45c453a1.webp";